import { CombinedFilter } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { OrderAttributes, OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';
import { map } from 'rxjs';
import get from 'lodash-es/get';
import { OrderCustomerService } from 'app/modules/components/reports/historic/order-customer/order-customer.service';
import { ExportStoreService } from '../export-overlay.store';
import { ExportFileFormat, ExportRange } from './core/export-task.enum';
import { LegacyExportTask } from './core/export-task-legacy';
import { OrdersListService } from 'app/modules/components/sales/order-list-components/order-list.service';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';

/** This class is instantiated by a factory (see ExportService).
 * The base ExportTask class takes care of all the functionality of the
 * task, like the current page, the progress and the status of the
 * task. */
export class SalesQuotationListExport extends LegacyExportTask {
    
    private datePipeFormat: FormatOtherDateHourPipe;

    constructor(
        itemCount: number,
        initialFilter: CombinedFilter<OrderAttributes>,
        private filterData: any,
        range: ExportRange,
        format: ExportFileFormat,
        store: ExportStoreService,
        private ordersListService: OrdersListService,
    ) {
        super('sales-quotation-list', 'Listado de cotizaciones', itemCount, range, format, initialFilter, store);
    }

    private transformObject(item: OrderAttributes) {
        const materials = get(item, 'detail', []).map((detail: any) => {
            return {
                code: get(detail, 'material.code', '??'),
                name: get(detail, 'material.name', '??'),
                unitPrice: get(detail, 'unitPrice', 0),
                totalPrice: get(detail, 'total', 0),
            };
        });

        return {
            trip: get(item, 'trip.id', '??'),
            route: `${get(item, 'subRoute.externalKeys.code', '??')} ${get(item, 'subRoute.name', '??')}`,
            user: get(item, 'user.user_login.username', '??'),
            responsibleBusinessPartner: `${get(item, 'responsibleBusinessPartner.externalKeys.code', '??')} ${get(item, 'responsibleBusinessPartner.name', '??')}`,
            soldTo: `${get(item, 'soldTo.externalKeys.code', '??')} ${get(item, 'soldTo.name', '??')}`,
            documentNumber: `${get(item, 'serial', '??')} ${get(item, 'externalKeys.code', '??')}`,
            class: get(item, 'class.name', '??'),
            subTotal: get(item, 'subTotal', 0),
            total: get(item, 'total', 0),
            //date: this.datePipeFormat.transform(get(item, 'creationDateTime', '??'), true),
            destination: `${get(item, 'shipTo.externalKeys.code', '??')} - ${get(item, 'shipTo.name', '??')}`,
            address: [
                get(item, 'address.address', ''),
                get(item, 'address.postalCode', ''),
                get(item, 'address.contactName', ''),
                get(item, 'address.locationTwo.name', ''),
                get(item, 'address.locationThree.name', ''),
            ].filter((s) => s).join(' / '),
            expeditionCondition: `${get(item, 'expeditionCondition.externalKeys.code', '')} - ${get(item, 'expeditionCondition.name', '')}`,
            paymentCondition: `${get(item, 'paymentCondition.externalKeys.code', '')} - ${get(item, 'paymentCondition.name', '')}`,
            note: get(item, 'note', '-'),
            details: materials            
        };
    }

    /** The main method of the export task class. Called for each page. Here do the request, process
     * and transform the data. The result for each request after processed must be an object array,
     * this object array will be later transformed to a file (xlsx, csv, json) automatically. */
    override onRequest(currentFilter: CombinedFilter<OrderAttributes>) {
        // To avoid displaying the global loading screen, the header x-ave-ctx is sent with the request,
        // the http interceptor finds that the header is set as 'export' and ignores the request, so
        // won't display the loading screen.
        return this.ordersListService.findByFilter(currentFilter, this.filterData, { contextHeader: 'export' }).pipe(
        map((response) => {
            return get(response, 'data.data', []).map((item) => this.transformObject(item));
        }),
        );
    }
}
